export default __webpack_public_path__ + "static/alchemy-hero-9ba26598f369fcbe329eed05bd713fb1.svg";